import React, { Component } from "react";
import DataCheckbox from "../DataCheckbox";
import { getDictItemList } from "../../service/dict";

import "./index.less";

export default class DictCheckbox extends Component {

  onLoad = () => {
    const { dict: dictCode, } = this.props;
    return getDictItemList({ dictCode, }).then(data => {
      const options = this.getOptions(data);
      return options;
    });
  };

  getOptions = (data) => {
    let options = [...data];
    options = options.map(item => ({
      label: item.label,
      value: this.parse(item.value),
    }));
    return options;
  };

  parse = (value) => {
    const { parse } = this.props;
    if (typeof parse === "string") {
      return {
        "number": Number,
        "string": String,
      }[parse](value);
    }
    return parse(value);
  };

  render() {
    return (
      <DataCheckbox
        {...this.props}
        onLoad={this.onLoad}
      />
    );
  };
};
